"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _utils = require("../../utils");

var _DetailedBox = _interopRequireDefault(require("../detailed-box/DetailedBox"));

var _helperComponents = require("../detailed-box/helperComponents");

var _propTypes = require("../radio/propTypes");

var _ = require("../");

var _constants = require("../constants");

var _utils2 = require("../utils");

var _Ring = _interopRequireDefault(require("./Ring"));

var _core = require("@emotion/core");

var _excluded = ["colorScheme", "details", "disabled", "error", "id", "titleText"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var dataTestComponentName = 'StencilDetailedRadio';

var getRingStyles = function getRingStyles(_ref) {
  var checked = _ref.checked,
      getColorParams = _ref.getColorParams,
      state = _ref.state;
  var innerCircleColor = (0, _utils2.getRingColor)(getColorParams);

  switch (state) {
    case 'active':
      {
        var checkedTextColor = (0, _utils2.getCheckedTextColor)(getColorParams);
        return {
          '.detailedRadioRing': {
            backgroundColor: innerCircleColor,
            borderColor: checked ? checkedTextColor : innerCircleColor
          }
        };
      }

    case 'focus':
      {
        var focusColor = (0, _utils2.getFocusColor)(getColorParams);
        return {
          '.detailedRadioRing': {
            backgroundColor: innerCircleColor,
            borderColor: focusColor
          }
        };
      }

    case 'hover':
      {
        var borderColor = (0, _utils2.getHoverColor)(getColorParams);
        var checkedBorderColor = (0, _utils2.getCheckedBackgroundColor)(getColorParams);
        return {
          '.detailedRadioRing': {
            backgroundColor: innerCircleColor,
            borderColor: checked ? checkedBorderColor : borderColor
          }
        };
      }

    default:
      {
        if (checked) {
          var _borderColor = (0, _utils2.getCheckedBorderColor)(getColorParams);

          return {
            '.detailedRadioRing': {
              backgroundColor: innerCircleColor,
              borderColor: _borderColor,
              borderWidth: (0, _utils.px)(_constants.CHECKED_RING_SIZE)
            }
          };
        }
      }
  }

  return {};
};

var DetailedRadioWithoutDocs = function DetailedRadioWithoutDocs(_ref2) {
  var _ref2$colorScheme = _ref2.colorScheme,
      colorScheme = _ref2$colorScheme === void 0 ? _.RadioColorScheme.Default : _ref2$colorScheme,
      details = _ref2.details,
      disabled = _ref2.disabled,
      error = _ref2.error,
      id = _ref2.id,
      titleText = _ref2.titleText,
      props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  var dataTestProps = (0, _utils.buildDataTestProps)({
    dataTestComponent: props['data-test-component'],
    dataTestId: props['data-test-id'] || titleText
  });
  return (0, _core.jsx)(_helperComponents.WrapperLabel, (0, _extends2.default)({
    htmlFor: id
  }, dataTestProps), (0, _core.jsx)(_helperComponents.InputHidden, (0, _extends2.default)({
    type: "radio"
  }, props, {
    "data-test-component": "DetailedRadioInput",
    "data-test-id": props.value,
    className: "stencilDetailedRadioHidden",
    disabled: disabled,
    id: id,
    "aria-invalid": error
  })), (0, _core.jsx)(_DetailedBox.default, {
    details: details,
    disabled: disabled,
    error: error,
    getInputStyles: getRingStyles,
    isInverted: colorScheme === _.RadioColorScheme.Inverted,
    titleText: titleText
  }, (0, _core.jsx)(_Ring.default, {
    className: "detailedRadioRing",
    colorScheme: colorScheme,
    disabled: disabled,
    error: error
  })));
};

var DetailedRadioWithDocs = (0, _stencilReactDesc.describe)(DetailedRadioWithoutDocs).description('Radio button with more detailed and lengthy explanation');
DetailedRadioWithDocs.propTypes = _objectSpread(_objectSpread({}, _propTypes.sharedRadioPropTypes), {}, {
  details: _stencilReactDesc.PropTypes.oneOfType([_stencilReactDesc.PropTypes.string, _stencilReactDesc.PropTypes.node]).description('Body text of the radio button. Should be more detailed explanation of the option.'),
  disabled: _stencilReactDesc.PropTypes.bool.description('Prevents the user from interacting with the detailed radio button.'),
  error: _stencilReactDesc.PropTypes.bool.description('Styles the detailed radio button to indicate that the value is incorrect.'),
  titleText: _stencilReactDesc.PropTypes.string.description('Title of the radio button. Should be a short description of the option.')
});
var DetailedRadio = (0, _utils.withTestAttributes)({
  component: dataTestComponentName
})(DetailedRadioWithDocs);
DetailedRadio.displayName = 'DetailedRadio';
var _default = DetailedRadio;
exports.default = _default;